
import AnnouncementList from './src/announcement/AnnouncementList.vue' //公告管理列表 
import AnnouncementInfo from './src/announcement/AnnouncementInfo.vue' //公告管理详情 

import AlarmList from './src/alarm/AlarmList.vue' //告警管理列表 
import AlarmInfo from './src/alarm/AlarmInfo.vue' //告警管理详情 

let views = {
  AnnouncementList,
  AnnouncementInfo,
  AlarmList,
  AlarmInfo
};

export default views;